var map = {
	"./FB_600X300": 4,
	"./FB_600X300.png": 4,
	"./apple": 5,
	"./apple.svg": 5,
	"./apple_logo": 6,
	"./apple_logo.png": 6,
	"./apple_sign": 7,
	"./apple_sign.png": 7,
	"./arrow-down-green": 8,
	"./arrow-down-green.svg": 8,
	"./arrow-down-white": 9,
	"./arrow-down-white.svg": 9,
	"./arrow-left-white": 10,
	"./arrow-left-white.svg": 10,
	"./arrow-right": 11,
	"./arrow-right-black": 12,
	"./arrow-right-black.svg": 12,
	"./arrow-right-white": 13,
	"./arrow-right-white.svg": 13,
	"./arrow-right.svg": 11,
	"./close-btn-black": 14,
	"./close-btn-black.svg": 14,
	"./close-btn-white": 15,
	"./close-btn-white.svg": 15,
	"./default-banner": 16,
	"./default-banner.png": 16,
	"./facebook-btn": 17,
	"./facebook-btn.png": 17,
	"./facebook-share-btn": 18,
	"./facebook-share-btn.png": 18,
	"./favicon.ico": 45,
	"./fb_logo": 19,
	"./fb_logo.png": 19,
	"./google-play": 20,
	"./google-play.svg": 20,
	"./heart": 21,
	"./heart.svg": 21,
	"./instagram-btn": 22,
	"./instagram-btn.png": 22,
	"./logo": 23,
	"./logo-green": 24,
	"./logo-green.svg": 24,
	"./logo-small": 25,
	"./logo-small.png": 25,
	"./logo.svg": 23,
	"./menu-btn": 26,
	"./menu-btn.svg": 26,
	"./micael_welcome": 27,
	"./micael_welcome.png": 27,
	"./noimg_user_xl": 28,
	"./noimg_user_xl.png": 28,
	"./page-first": 29,
	"./page-first.svg": 29,
	"./page-last": 30,
	"./page-last.svg": 30,
	"./page-next": 31,
	"./page-next.svg": 31,
	"./page-prev": 32,
	"./page-prev.svg": 32,
	"./product_no_image": 33,
	"./product_no_image.png": 33,
	"./profile_camera": 34,
	"./profile_camera.png": 34,
	"./search": 35,
	"./search.svg": 35,
	"./star-full": 36,
	"./star-full.svg": 36,
	"./star-half": 37,
	"./star-half.svg": 37,
	"./star-no": 38,
	"./star-no.svg": 38,
	"./wechat_logo": 39,
	"./wechat_logo.svg": 39
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44;